import React,{Component} from 'react';

import {Col,Row,Pagination} from 'react-bootstrap';

import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Filters from './components/Filters';
import UsersTable from './components/UsersTable';

import API from '../../services/API';

class Users extends Component {
    constructor() {
        super();

        this.state = {
            countries: [],
            total: '',
            pagesTotal: 0,
            activePage: 1,
            rows: [],
            filters: {},
            isLoading: false
        };

        this.handlePageSelect = this.handlePageSelect.bind(this);
        this.handleFiltersSubmit = this.handleFiltersSubmit.bind(this);
    }

    componentDidMount() {
        this.loadCountries();
        this.loadUsers();
    }

    componentDidUpdate(nextProps,prevState) {
        if(this.state.filters !== prevState.filters || this.state.activePage !== prevState.activePage) {
            this.loadUsers() ;
        }
    }

    handleFiltersSubmit(filters) {
        this.setState({filters});
    }

    handlePageSelect(activePage) {
        this.setState({activePage});
    }

    loadCountries() {
        API.Users.getCountries().then((countries) => {
            this.setState({countries});
        });
    }

    loadUsers() {
        const {activePage,filters} = this.state;
        this.setState({
            isLoading: true
        });

        API.Users.getPage(activePage,filters).then((res) => {
            this.setState({
                ...res,
                isLoading: false
            });
        });
    }


    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Users"/>
                <Row>
                    <Col lg={12}>
                        <Filters
                            countries={this.state.countries}
                            onSubmit={this.handleFiltersSubmit}/>
                        <h3>Users total: {this.state.total}</h3>
                        <UsersTable users={this.state.rows}/>
                    </Col>
                </Row>
                <Pagination
                    items={this.state.pagesTotal}
                    maxButtons={20}
                    onSelect={this.handlePageSelect}
                    activePage={this.state.activePage}
                />
            </Container>
        );
    }


}

export default Users;


// WEBPACK FOOTER //
// ./src/scenes/Users/index.js